import { render, staticRenderFns } from "./BdQRCode.vue?vue&type=template&id=a275d8f0&scoped=true&"
import script from "./BdQRCode.vue?vue&type=script&lang=js&"
export * from "./BdQRCode.vue?vue&type=script&lang=js&"
import style0 from "./BdQRCode.vue?vue&type=style&index=0&id=a275d8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a275d8f0",
  null
  
)

export default component.exports